import * as yup from "yup"


const canadianPhoneRegExp = /^(?:(?:\+1|1-)?(?:\(\d{3}\)|\d{3})[-.]\d{3}[-.]\d{4}|(?:\+1|1-)?\d{10})$/;
const userRegExp = /^[a-zA-Z0-9\s]*$/;

export const UpdateDriverSchema = yup.object().shape({
  email: yup.string().email("Please enter a valid email").required("Required"),
  firstName: yup.string().required("Required"),
  phoneNumber: yup.string().matches(canadianPhoneRegExp, "Invalid Canadian phone number").required("Required"),
  lastName: yup.string().required("Required"),
  percentage: yup.number()
    .typeError('Invalid percentage')
    .required('Percentage is required')
    .min(0, 'Percentage must be greater than or equal to 0')
    .max(100, 'Percentage must be less than or equal to 100'),
  vehicleType: yup.string().required('Vehicle Type is required'),
  mobileDeviceType: yup.string().required('Mobile Device Type is required'),
  userName: yup.string().matches(userRegExp, "Only letters and numbers are allowed!").required("Required"),
}

)